<template>
  <div style="display: flex; gap: 10px; flex-direction: column">
    <div class="m-card">
      <div
        style="
          display: flex;
          flex-direction: column;
          gap: 5px;
          justify-content: space-around;
        "
      >
        <div style="display: flex; justify-content: space-between">
          <div style="font-size: 1.25rem; font-weight: bold">
            {{ item.name }}
          </div>
          <!-- <div  v-if="user_role === 'admin'">
            <vs-button
              @click="$bvModal.show('modal-' + item.name.slice(' ')[0])"
              radius
              color="success"
              type="flat"
              icon="settings"
            ></vs-button>
          </div> -->
        </div>
        <b-modal
          :id="'modal-' + item.name.slice(' ')[0]"
          ref="modal-2"
          hide-header-close
          centered
          size="lg"
        >
          <template #modal-title>
            <h4 class="textSuccess">Color Rule Setting</h4>  
          </template>
          <span
            class="mb-2"
            style="
              font-size: 0.85rem;
              padding-left: 5px;
              color: rgba(0, 0, 0, 0.6);
            "
            >Select Color Rule of Temperature</span
          >
          <vs-row class="mb-3 mt-3" v-for="i in optionsColor_new" :key="i" vs-w="8">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="3"
              vs-sm="4"
              vs-xs="3"
            >
              <span :class="i.color">{{ i.text }}</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="3"
              vs-sm="4"
              vs-xs="2"
            >
              <b-form-input
                v-if="i.value1 != undefined"
                v-model="i.value1"
                step="0.1"
                type="number"
                aria-label="Text input with checkbox"
              ></b-form-input>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="1"
            >
              {{ i.icon }}
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="3"
              vs-sm="4"
              vs-xs="2"
            >
              <b-form-input
                v-model="i.value2"
                step="0.1"
                type="number"
                aria-label="Text input with checkbox"
              ></b-form-input>
            </vs-col>
          </vs-row>
          <template #modal-footer="{}">
            <vs-button
              color="primary"
              @click="editColor"
              class="mr-1 btnBorderpop"
              type="filled"
              >Save</vs-button
            >
            <vs-button
              @click="$bvModal.hide('modal-' + item.name.slice(' ')[0])"
              class="btnBorderpop"
              color="dark"
              type="flat"
              style="color: var(--text-color-2)"
              >Cancel</vs-button
            >
          </template>
        </b-modal>
        <div
          style="
            display: flex;
            gap: 5px;
            justify-content: space-around;
            align-items: center;
          "
        >
          <div style="width: 70%; position: relative">
            <img :src="item.img" width="100%" alt="" />
            <div
              v-for="(gateway, gateway_i) in item.gateway"
              :key="gateway_i"
              style="
                position: absolute;
                width: 50px;
                height: 50px;
                border-radius: 25px;
              "
              :style="{
                top: gateway.y + '%',
                left: gateway.x + '%',
                'box-shadow':
                  ' 0 0px 12px 6px' +
                  (gateway.status == 1 ? '#32c040' : '#808080'),
              }"
            >
              <img src="@/assets/images/gateway.png" width="50" alt="" />
            </div>
            <div
              v-for="(sensor, sensor_i) in item.sensor"
              :key="sensor_i"
              :id="item.name.slice(' ')[0] + 'temp-' + sensor_i"
              style="
                position: absolute;
                background: #fff;
                color: #000;
                border: 2px solid;
                width: 70px;
                height: 70px;
                border-radius: 50px;
                font-size: 1.25rem;
                font-weight: bold;
                display: flex;
                align-items: center;
                justify-content: center;
              "
              :style="{
                top: sensor.y + '%',
                left: sensor.x + '%',
                'border-color': colorTemp(item.gateway[0], sensor),
              }"
            >
              {{ sensor.temp.toFixed(1) }}°C
              <b-tooltip
                :target="item.name.slice(' ')[0] + 'temp-' + sensor_i"
                placement="bottom"
              >
                Temp <strong>{{ sensor.temp }}°C</strong> Hum
                <strong>{{ sensor.hum }}%</strong> mac
                <strong>{{ sensor.mac }}</strong>
              </b-tooltip>
            </div>
          </div>
          <div>
            <div style="display: flex; align-items: center; gap: 5px">
              <img src="@/assets/images/gateway.png" height="100" alt="" />
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  gap: 5px;
                  align-items: center;
                "
              >
                <div>
                  {{ item.gateway[0].status }}/{{ item.gateway.length }}
                </div>
                <div
                  style="
                    border-radius: 5px;
                    background: #3a59ae;
                    padding: 5px;
                    color: #fff;
                    font-weight: bold;
                  "
                >
                  GATEWAYS
                </div>
              </div>
            </div>
            <div style="display: flex; align-items: center; gap: 5px">
              <img src="@/assets/images/tempsensor.png" height="100" alt="" />
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  gap: 5px;
                  align-items: center;
                "
              >
                <div>
                  {{ item.gateway[0].status == 1 ? item.sensor.length : 0 }}/{{
                    item.sensor.length
                  }}
                </div>
                <div
                  style="
                    border-radius: 5px;
                    background: #3aaea6;
                    padding: 5px;
                    color: #fff;
                    font-weight: bold;
                  "
                >
                  SENSORS
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="width: 100%; text-align: end">
        {{ item.gateway[0].timestamp }}
      </div>
    </div>
    <div
      class="m-card vs-con-loading__container"
      :id="'loading-' + item.name.slice(' ')[0]"
    >
      <div>
        <h3 style="font-weight: bold">Data of {{ item.name }}</h3>
      </div>
      <div>
        <LineChart
          :height="250"
          :chartdata="chartData"
          :options="optionsChart"
          :areaColors="['#A3A1FB', '#007bff']"
          :heightChart="200"
        />
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div style="display: flex; align-items: center; gap: 5px">
            <div style="display: flex; align-items: center; gap: 5px">
              <div
                style="width: 30px; height: 15px; border-radius: 5px"
                :style="'background-color: ' + '#A3A1FB' + ';'"
              ></div>
              Temperature
            </div>
            <div style="display: flex; align-items: center; gap: 5px">
              <div
                style="width: 30px; height: 15px; border-radius: 5px"
                :style="'background-color: ' + '#007bff' + ';'"
              ></div>
              Humidity
            </div>
          </div>
          <div style="display: flex; align-items: center; gap: 10px">
            <div class="box-chart">
              <p
                style="font-weight: 800; margin-bottom: 0.5rem; color: #ffa807"
              >
                avg
              </p>
              <p>{{ avg.toFixed(2) }}°C</p>
            </div>
            <div class="box-chart">
              <p
                style="font-weight: 800; margin-bottom: 0.5rem; color: #f707ff"
              >
                min
              </p>
              <p>{{ min.toFixed(2) }}°C</p>
            </div>
            <div class="box-chart">
              <p
                style="font-weight: 800; margin-bottom: 0.5rem; color: #8f07ff"
              >
                max
              </p>
              <p>{{ max.toFixed(2) }}°C</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="m-card" id="table" :class="{ disabled: disabled }">
      <h3 style="font-weight: bold">List of {{ item.name }}</h3>
      <b-table
        :items="item.sensor"
        :fields="fields"
        responsive="sm"
        @row-selected="onRowSelected"
        :ref="'selectableTable' + item.name.slice(' ')[0]"
        selectable
        select-mode="single"
      >
        <template #head()="data">
          <div style="display: flex; width: 100%; justify-content: center">
            <span class="" style="color: var(--text-color)">
              {{ data.label }}
            </span>
          </div>
        </template>
        <template #cell()="data">
          <div style="display: flex; width: 100%; justify-content: center">
            <span class="" style="color: var(--text-color-2)">
              {{ data.value }}
            </span>
          </div>
        </template>
        <template #cell(battery)="data">
          <div style="display: flex; width: 100%; justify-content: center">
            <span class="" style="color: var(--text-color-2)">
              {{ data.value }}%
              <!-- <vs-icon
                v-if="data.value >= 90"
                icon="battery_full"
                color="primary"
              ></vs-icon>
              <vs-icon
                v-else-if="data.value >= 80"
                icon="battery_6_bar"
                color="primary"
              ></vs-icon>
              <vs-icon
                v-else-if="data.value >= 65"
                icon="battery_5_bar"
                color="primary"
              ></vs-icon>
              <vs-icon
                v-else-if="data.value >= 50"
                icon="battery_4_bar"
                color="primary"
              ></vs-icon>
              <vs-icon
                v-else-if="data.value >= 40"
                icon="battery_3_bar"
                color="warning"
              ></vs-icon>
              <vs-icon
                v-else-if="data.value >= 25"
                icon="battery_2_bar"
                color="warning"
              ></vs-icon>
              <vs-icon
                v-else-if="data.value >= 10"
                icon="battery_1_bar"
                color="danger"
              ></vs-icon>
              <vs-icon
                v-else-if="data.value >= 0"
                icon="battery_0_bar"
                color="danger"
              ></vs-icon> -->
            </span>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import LineChart from "@/components/ChartJs/LineChart.vue";

export default {
  components: {
    LineChart,
  },
  props: {
    item: Object,
  },
  data() {
    return {user_role:"",
      fields: [
        { key: "name", label: "Sensor Name" },
        { key: "mac", label: "Mac address" },
        { key: "temp", label: "Temperature" },
        { key: "hum", label: "Humidity" },
        { key: "battery", label: "Battery" },
        { key: "location", label: "Location" },
        { key: "timestamp", label: "Timestamp" },
      ],
      optionsColor: [
        { text: "Red", value2: 28.3 },
        {
          text: "Yellow",
          value1: 27.7,
          value2: 28.3,
        },
        {
          text: "Green",
          value2: 27.7,
        },
      ],
      optionsColor_new: [
        { text: "Red", icon: ">", color: "textDanger", value2: 28.3 },
        {
          text: "Yellow",
          icon: "-",
          color: "textYellow",
          value1: 27.7,
          value2: 28.3,
        },
        {
          text: "Green",
          icon: "<",
          color: "colorSuccess",
          value2: 27.7,
        },
      ],
      chartData: {
        datasets: [
          {
            data: [],
            label: "Tempreture ( °C )",
            pointBorderWidth: 1,
            borderWidth: 3,
            borderColor: "#A3A1FB",
            //     backgroundColor:  this.gradient,
          },
          {
            data: [],
            label: "Tempreture ( °C )",
            pointBorderWidth: 1,
            borderWidth: 3,
            borderColor: "#007bff",
          },
        ],
        labels: [],
      },
      optionsChart: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: false,
          title: {},
          position: "bottom",
        },
        scales: {
          yAxes: [
            {
              ticks: {
                step: 1,
              },
              scaleLabel: {
                display: true,
              },
            },
          ],
        },
      },
      datalog: [],
      selected: [],
      max: 0,
      min: 0,
      avg: 0,
      timeout: null,
      disabled: false,
    };
  },
  methods: {
    chart() {},
    colorTemp(gateway, sensor) {
      if (gateway.status == 1) {
        if (sensor.temp > this.optionsColor[0].value2) {
          return "#e74639";
        }
        if (sensor.temp < this.optionsColor[2].value2) {
          return "#32c040";
        }
        if (
          sensor.temp >= this.optionsColor[1].value1 &&
          sensor.temp <= this.optionsColor[1].value2
        ) {
          return "#ffa200";
        }
        return ''
      }
      return "#808080";
    },
    async editColor() {
      try {
        let body = {
          location: this.item.location,
          room: this.item.room,
          color: {
            red: parseFloat(this.optionsColor_new[0].value2),
            yellow: [parseFloat(this.optionsColor_new[1].value1), parseFloat(this.optionsColor_new[1].value2)],
            green: parseFloat(this.optionsColor_new[2].value2),
          },
        };
        console.log(body);
        let res = await this.$API.post("dnet/edit", body);
        console.log("dnet/edit",res);
        this.getConditionColor()
        this.$bvModal.hide('modal-' + this.item.name.slice(' ')[0])
        this.$vs.notify({
          title: "Save Color Rule Success",
          text:
            "red " +
            this.optionsColor_new[0].value2 +
            "<br>yellow " +
            this.optionsColor_new[1].value1 +
            " - " +
            this.optionsColor_new[1].value2 +
            "<br>green " +
            this.optionsColor_new[2].value2,
          color: "#32c040",
          position: "top-center",
        });
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Can not Save Color Rule Success",
          color: "danger",
          position: "top-center",
        });
      }
    },
    async getConditionColor() {
      try {
        let body = {
          location: this.item.location,
          room: this.item.room,
        };
        let res = await this.$API.post("dnet/get", body);
        console.log(res.data[0]);
        this.optionsColor[0].value2 = res.data[0].color.red
        this.optionsColor[1].value1 = res.data[0].color.yellow[0]
        this.optionsColor[1].value2 = res.data[0].color.yellow[1]
        this.optionsColor[2].value2 = res.data[0].color.green

        this.optionsColor_new[0].value2 = res.data[0].color.red
        this.optionsColor_new[1].value1 = res.data[0].color.yellow[0]
        this.optionsColor_new[1].value2 = res.data[0].color.yellow[1]
        this.optionsColor_new[2].value2 = res.data[0].color.green

      } catch (error) {}
    },
    onRowSelected(items) {
      console.log("onRowSelected");
      this.selected = items;
      // console.log(this.selected);
      if (this.selected.length > 0) {
        this.getSensorLog();
      }
    },

    async getGateway() {
      let res = await this.$API.get(
        `indoorgateway/${this.item.gateway[0].MAC}`
      );
      console.log(res);
    },
    async getSensorLog() {
      this.disabled = true;
      this.$vs.loading({
        container: "#loading-" + this.item.name.slice(" ")[0],
        scale: 0.6,
      });
      try {
        let res = await this.$API.get(
          `gmt/indoorsensorlog/${this.selected[0].mac}`
        );
        console.log(res);
        let total = 0;
        this.max = res.data[res.data.length - 1].sensordata.temperature;
        this.min = res.data[res.data.length - 1].sensordata.temperature;
        let temp = [];
        let hum = [];

        let labels = [];
        for (let i = 0; i < res.data.length; i++) {
          const el = res.data[i];
          this.max =
            el.sensordata.temperature > this.max
              ? el.sensordata.temperature
              : this.max;
          this.min =
            el.sensordata.temperature < this.min
              ? el.sensordata.temperature
              : this.min;
          total += el.sensordata.temperature;
          temp.push(el.sensordata.temperature);
          hum.push(el.sensordata.humidity);
          labels.push(el.timestamp);
        }

        this.avg = total / res.data.length;
        // console.log(temp, labels);
        this.chartData.datasets[0].data = temp;
        this.chartData.datasets[1].data = hum;
        this.chartData.labels = labels;
      } catch (error) {}
      this.disabled = false;
      this.$vs.loading.close(
        "#loading-" + this.item.name.slice(" ")[0] + " > .con-vs-loading"
      );
    },
    async calldata() {
      // for (let i = 0; i < this.item.sensor.length; i++) {
      //   const el = this.item.sensor[i];
      //   // console.log(el);
      // await this.getSensorLog(el)
      // }
      // this.timeout = setTimeout(async () => {
      //   await this.getGateway();
      //   await this.getSensor();
      // }, 30 * 1000);
    },
  },
  mounted() {
    console.log(this.item);
    this.getConditionColor()
    this.$refs["selectableTable" + this.item.name.slice(" ")[0]].selectRow(0);
  this.user_role = this.$session.get("role");
    // this.calldata()
  },
};
</script>

<style lang="scss" scoped>
.box-chart {
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    margin: 0;
  }
}
.disabled {
  pointer-events: none;
}

:fullscreen {
  #table {
    display: none;
  }
}
</style>
